<template>
  <!-- 群角色设置 -->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="applyrole"
    role="dialog"
    data-backdrop="static"
    tabindex="-1"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="myModalLabel">
            群角色设置 <span class="fz-14">{{ modeText[mode].title }}</span>
          </h4>
        </div>
        <div class="modal-body" v-if="mode === 'list'">
          <div class="form-group">
            <div class="group-list-wrap clearfix">
              <p v-show="!groupRoles.length">{{ processing }}</p>
              <div
                class="group-list"
                v-for="(role, index) in groupRoles"
                :key="index"
              >
                <div class="head">
                  {{ index + 1 + (params.page - 1) * params.per_page }}
                </div>
                <div class="name" :title="role.role_name">
                  {{ role.role_name }}
                </div>
                <div class="style" :title="role.role_note">
                  {{ role.role_type === 1 ? "【仅群主可见】" : ""
                  }}{{ role.role_note }}
                </div>
                <div class="info">
                  <a
                    title="删除角色"
                    @click="deleteGroupRole(role.id, index)"
                    v-if="right__group_role_delete && role.role_type === 0"
                    ><i class="ti-trash"></i
                  ></a>
                  <a
                    title="配置用户"
                    @click="editRoleUser(role.id)"
                    v-if="right__group_role_member_edit && hasManageGroupRoleMemberPermission"
                    ><i class="ti-user"></i
                  ></a>
                  <a title="编辑角色" @click="editRole(role.id)" v-if="right__group_role_edit"
                    ><i class="iconfont icon-send fz-14"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div class="page" v-if="groupRoles.length > 5">
            <ul>
              <li>
                <a
                  :class="{ disable: params.page <= 1 }"
                  title="上一页"
                  @click="prevPage"
                  ><i class="ti-angle-left"></i
                ></a>
              </li>
              <li>
                <a
                  :class="{ disable: !hasNextPage }"
                  title="下一页"
                  @click="nextPage"
                  ><i class="ti-angle-right"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-body" v-if="mode === 'add' || mode === 'edit'">
          <div class="form-group row">
            <label class="col-sm-3 control-label">角色名称</label>
            <div class="col-sm-9">
              <input
                class="form-control"
                placeholder="角色名称"
                type="text"
                v-model.trim="roleForm.role_name"
                name="role_name"
                data-vv-as="角色名称 "
                v-validate="{ required: true, max: 20 }"
              />
              <span class="help-block" v-show="errors.has('role_name')">{{
                errors.first("role_name")
              }}</span>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 control-label">角色简介</label>
            <div class="col-sm-9">
              <textarea
                class="form-control"
                placeholder="角色简介"
                style="resize: vertical"
                rows="3"
                v-model.trim="roleForm.role_note"
                name="role_note"
                data-vv-as="角色简介 "
                v-validate="{ required: true, max: 100 }"
              ></textarea>
              <span class="help-block" v-show="errors.has('role_note')">{{
                errors.first("role_note")
              }}</span>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 control-label"
              >公共权限（{{ roleForm.public_operations.length }} /
              {{ publicPermissionLength }}）</label
            >
            <div class="col-sm-9">
              <div class="file-move">
                <!-- <div id="treeview-public-permission"></div> -->
                <div class="treeview" style="height: 250px">
                  <ul
                    class="list-group"
                    v-for="(item, index) in publicPermissionTree"
                    :key="index"
                  >
                    <li class="list-group-item">
                      <span class="indent"></span>{{ item.opera_type_id }}.
                      {{ item.opera_type_name }}
                    </li>
                    <li
                      :class="[
                        'list-group-item',
                        item2.disabled ? 'node-disabled' : '',
                      ]"
                      :style="{ cursor: item2.disabled ? 'unset' : 'pointer' }"
                      v-for="(item2, index2) in item.opera_list"
                      :key="index2"
                      @click="handleSelectPublicPermission(item2)"
                    >
                      <span class="indent"></span
                      ><span class="icon glyphicon"></span
                      ><span
                        :class="[
                          'icon',
                          'node-icon',
                          'glyphicon',
                          item2.selected
                            ? 'glyphicon-check'
                            : 'glyphicon-unchecked',
                        ]"
                      ></span
                      >{{ item2.opera_name }}
                    </li>
                  </ul>
                </div>
              </div>
              <span
                class="help-block"
                v-show="errors.has('public_operations')"
                >{{ errors.first("public_operations") }}</span
              >
            </div>
          </div>
        </div>
        <div class="modal-body" v-if="mode === 'user'">
          <div class="form-group row">
            <div class="col-sm-3">角色名称</div>
            <div class="col-sm-9">{{ roleForm.role_name }}</div>
          </div>
          <div class="form-group row">
            <div class="col-sm-3">角色简介</div>
            <div class="col-sm-9">{{ roleForm.role_note }}</div>
          </div>
          <div class="form-group row">
            <div class="col-sm-3">
              选择用户（{{ groupMembers.length }} / {{ memberTree.length }}）
            </div>
            <div class="col-sm-9">
              <div class="file-move">
                <div id="treeview-member"></div>
              </div>
              <span class="help-block" v-show="errors.has('treeview-member')">{{
                errors.first("treeview-member")
              }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" type="button" @click="cancle">
            关闭
          </button>
          <button
            class="btn btn-default"
            type="button"
            v-if="modeText[mode].back"
            @click="switchMode('list')"
          >
            返回
          </button>
          <button class="btn btn-primary" type="button" @click="handleSubmit" v-if="mode != 'list' || right__group_role_create">
            {{ modeText[mode].button }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getGroupRoleList,
  getGroupRoleInfo,
  getGroupRoleOperations,
  addGroupRole,
  saveGroupRole,
  getGroupMembers,
  setGroupRoleMembers,
  deleteGroupRole,
  getGroupRoleMembers,
} from "@/api/group/group";
export default {
  name: "GroupRole",
  data() {
    return {
      processing: "未搜索到相关内容",
      params: {
        group_id: this.group_number,
        role_name: "",
        page: 1,
        per_page: 5,
      },
      total: 0, // 群角色总数
      groupRoles: [], // 群角色列表
      mode: "list", // list列表，add新增，edit编辑
      modeText: {
        list: {
          title: "角色列表",
          button: "新增群角色",
          close: true,
          back: false,
        },
        add: {
          title: "新增角色",
          button: "保存",
          close: false,
          back: true,
        },
        edit: {
          title: "编辑角色",
          button: "保存",
          close: false,
          back: true,
        },
        user: {
          title: "配置用户",
          button: "保存",
          close: false,
          back: true,
        },
      },
      roleForm: {
        group_id: this.group_number,
        role_id: 0,
        role_name: "",
        role_note: "",
        public_operations: [],
      },
      groupMembers: [],
      publicPermissionTree: [],
      publicPermissionLength: 0,
      memberTree: [],
    };
  },
  props: {
    group_number: {
      type: String,
    },
  },
  computed: {
    right__group_role_delete () {
      return this.$store.getters.right__group_role_delete
    },
    right__group_role_member_edit () {
      return this.$store.getters.right__group_role_member_edit
    },
    right__group_role_edit () {
      return this.$store.getters.right__group_role_edit
    },
    right__group_role_create () {
      return this.$store.getters.right__group_role_create && (this.mode === 'list' || this.mode === 'add')
    },
    hasNextPage() {
      return Math.ceil(this.total / this.params.per_page) > this.params.page;
    },
    permissions() {
      return this.$store.state.group.permissions;
    },
    isOwner() {
      return (
        this.$store.state.group.groupInfo.group_member_identity === "owner"
      );
    },
    // 管理角色成员
    hasManageGroupRoleMemberPermission() {
      return (
        this.permissions.public_operations === "ALL" ||
        this.permissions.public_operations.indexOf("manageGroupRoleMember") > -1
      );
    },
  },
  methods: {
    handleSelectPublicPermission(item) {
      if(item.disabled){
        return false;
      }
      if (item.selected) {
        const index = this.roleForm.public_operations.indexOf(item.id);
        this.roleForm.public_operations.splice(index, 1);
        item.selected = false;
      } else {
        this.roleForm.public_operations.push(item.id);
        item.selected = true;
        this.errors.remove("public_operations");
      }
    },
    prevPage() {
      if (this.params.page > 1) {
        this.getGroupRoleList(this.params.page - 1);
      }
    },
    nextPage() {
      if (this.hasNextPage) {
        this.getGroupRoleList(this.params.page + 1);
      }
    },
    handleSubmit() {
      switch (this.mode) {
        case "list":
          this.mode = "add";
          this.roleForm.role_id = 0;
          this.roleForm.role_name = "";
          this.roleForm.role_note = "";
          this.roleForm.public_operations = [];
          this.treeview(null);
          break;
        case "add":
          this.addGroupRole();
          break;
        case "edit":
          this.saveGroupRole();
          break;
        case "user":
          this.setGroupRoleMembers();
          break;
      }
    },
    setGroupRoleMembers() {
      // if (!this.groupMembers.length) {
      //   this.errors.add({
      //     field: "treeview-member",
      //     msg: "请选择用户",
      //   });
      //   return false;
      // }
      setGroupRoleMembers({
        role_id: this.roleForm.role_id,
        user_ids: this.groupMembers,
      }).then((res) => {
        if (res.status_code === 200) {
          this.$message({
            type: "success",
            message: res.message,
          });
          this.mode = "list";
          this.getGroupRoleList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    // 编辑角色
    saveGroupRole() {
      this.$validator.validate().then((valid) => {
        // if (!this.roleForm.public_operations.length) {
        //   this.errors.add({
        //     field: "public_operations",
        //     msg: "请选择公共权限",
        //   });
        //   valid = false;
        // }
        if (valid) {
          saveGroupRole({
            group_id: this.group_number,
            role_id: this.roleForm.role_id,
            role_name: this.roleForm.role_name,
            role_note: this.roleForm.role_note,
            operation_ids: this.roleForm.public_operations,
          }).then((res) => {
            if (res.status_code === 200) {
              this.$message({
                type: "success",
                message: res.message,
              });
              this.mode = "list";
              this.getGroupRoleList();
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        }
      });
    },
    // 添加角色
    addGroupRole() {
      this.$validator.validate().then((valid) => {
        // if (!this.roleForm.public_operations.length) {
        //   this.errors.add({
        //     field: "public_operations",
        //     msg: "请选择公共权限",
        //   });
        //   valid = false;
        // }
        if (valid) {
          addGroupRole(this.roleForm).then((res) => {
            if (res.status_code === 200) {
              this.$message({
                type: "success",
                message: res.message,
              });
              this.mode = "list";
              this.getGroupRoleList();
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        }
      });
    },
    deleteGroupRole(role_id, index) {
      deleteGroupRole({
        gid: this.group_number,
        role_id: role_id,
      }).then((res) => {
        if (res.status_code === 200) {
          this.$message({
            type: "success",
            message: res.message,
          });
          this.groupRoles.splice(index, 1);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    editRoleUser(role_id) {
      this.getGroupRoleInfo(role_id, "user");
    },
    editRole(role_id) {
      this.getGroupRoleInfo(role_id, "edit");
    },
    getGroupRoleInfo(role_id, mode) {
      getGroupRoleInfo({
        role_id: role_id,
      }).then((res) => {
        if (res.status_code === 200) {
          this.roleForm.role_id = res.entity.id;
          this.roleForm.role_name = res.entity.role_name;
          this.roleForm.role_note = res.entity.role_note;
          this.roleForm.public_operations = res.entity.operation_ids.map(
            (item) => item.id
          );
          this.mode = mode;
          if (mode === "edit") {
            this.treeview(role_id);
          } else if (mode === "user") {
            this.userTreeview();
          }
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    switchMode(mode = false) {
      if (mode) {
        this.mode = mode;
        $("#applyrole").css({ "margin-top": "0px" });
        return false;
      }
    },
    getGroupRoleList(page = 1) {
      $("#applyrole").css({ "margin-top": "0px" });
      this.mode = "list";
      let params = Object.assign({}, this.params, { page });
      getGroupRoleList(params)
        .then((res) => {
          if (res.status_code === 200) {
            this.processing = "暂无群角色";
            this.groupRoles = res.entity.datas;
            this.params.page = page;
            this.total = res.entity.total;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    async userTreeview() {
      $("#applyrole").css({ "margin-top": "-30px" });
      await getGroupRoleMembers({
        role_id: this.roleForm.role_id,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.groupMembers = res.entity.member_infos.map((item) => item.id);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });

      await getGroupMembers({
        group_number: this.group_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.memberTree = res.entity
              .filter((item) => {
                return item.group_member_identity != "owner";
              })
              .map((item) => {
                return {
                  text: `<img class="tree-avatar" src="${item.group_member_avatar}"> ${item.group_member_name}（${item.group_member_email}）`,
                  number: item.group_member_number,
                  state: {
                    selected: this.groupMembers.length
                      ? this.groupMembers.indexOf(item.group_member_number) > -1
                      : false,
                  },
                };
              });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
      $("#treeview-member").treeview({
        multiSelect: true,
        expandIcon: "ti ti-angle-right",
        collapseIcon: "ti ti-angle-down",
        nodeIcon: "glyphicon glyphicon-unchecked",
        showTags: true,
        selectedIcon: "glyphicon glyphicon-check",
        onNodeSelected: (event, data) => {
          this.groupMembers.push(data.number);
          this.errors.remove("treeview-member");
        },
        onNodeUnselected: (event, data) => {
          const index = this.groupMembers.indexOf(data.number);
          this.groupMembers.splice(index, 1);
        },
        data: this.memberTree,
      });
    },
    treeview(role_id) {
      $("#applyrole").css({ "margin-top": "-15px" });
      getGroupRoleOperations({
        gid: this.group_number,
        role_id: role_id,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.publicPermissionLength = 0;
            this.publicPermissionTree = res.entity.map((item) => {
              item.opera_list.map((item1) => {
                item1.selected =
                  this.roleForm.public_operations.indexOf(item1.id) > -1;
                item1.disabled = item1.sensitive_type === 2 && !this.isOwner;
                this.publicPermissionLength++;
                return item1;
              });
              return item;
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
      // $("#treeview-public-permission").treeview({
      //   multiSelect: true,
      //   expandIcon: "ti ti-angle-right",
      //   collapseIcon: "ti ti-angle-down",
      //   nodeIcon: "glyphicon glyphicon-unchecked",
      //   showTags: true,
      //   selectedIcon: "glyphicon glyphicon-check",
      //   onNodeSelected: (event, data) => {
      //     this.roleForm.public_operations.push(data.operation_id);
      //     this.errors.remove("public_operations");
      //   },
      //   onNodeUnselected: (event, data) => {
      //     const index = this.roleForm.public_operations.indexOf(
      //       data.operation_id
      //     );
      //     this.roleForm.public_operations.splice(index, 1);
      //   },
      //   data: this.publicPermissionTree,
      // });
    },
    cancle() {
      $("#applyrole").modal("hide");
      this.$validator.reset();
    },
  },
  mounted() {
    $("#applyrole").on("show.bs.modal", () => {
      this.getGroupRoleList();
    });
    // $("#applyrole").modal("show");
  },
  destroyed() {
    $("#applyrole").off();
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .modal-lg {
    width: auto;
  }
  .group-list .head {
    display: none;
  }
  .group-list .name {
    width: 80px !important;
    padding-left: 0 !important;
  }
  .group-list .style {
    width: 150px !important;
    padding-left: 0 !important;
  }
  .group-list .info {
    padding-left: 0 !important;
  }
}
.group-list-wrap {
  height: 256px;
}
.group-list .name {
  width: 100px;
}
.group-list .style {
  width: 350px;
  float: left;
  padding-left: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.group-list .info {
  padding-left: 10px;
  float: right;
  width: auto;
}
.group-list .info a {
  margin-left: 8px;
  float: right;
}
.fz-14 {
  font-size: 14px;
}
.ti-back-left {
  font-weight: bold;
}
.modal-body {
  padding: 0 30px 0px 30px;
}
.modal-body .form-group label {
  height: 36px;
  line-height: 36px;
}
.treeview {
  height: 150px;
  padding: 5px 0;
}
#treeview-member {
  height: 250px;
}
.close-treeview-resource-permission {
  position: absolute;
  top: 15px;
  right: 30px;
  z-index: 999;
  cursor: pointer;
  background-color: #006adf;
  border: 1px solid #006adf;
  /* border-radius: 5px; */
  padding: 3px;
  color: #fff;
}
.close-treeview-resource-permission:hover {
  background-color: #0052ac;
}

/*分页*/
.disable {
  color: #eee;
}
.disable:hover {
  color: #eee !important;
  background-color: unset !important;
  cursor: unset;
}
.page {
  width: 100%;
}
.page ul li {
  display: inline-block;
  margin: 0 2px;
}
.page ul li a {
  min-width: 30px;
  height: 30px;
  display: block;
  text-align: center;
  line-height: 30px;
}
.page ul li a:hover {
  background: #006adf;
  color: #fff;
}
</style>